<div class="collegues_container">
    <div class="content">
        <div class="title">
            <h1 id="teamplayerNeeded">Teamplayer gesucht?</h1>
            <h2 id="whatColleguesSaid">Das sagen meine Kollegen über mich</h2>
        </div>

        <div class="reviews">
            <div class="single-review">
                <div>
                    <span class="collegue_name">Sydney Bär</span>
                    <span class="project" id="project_join">Projekt Join</span>
                </div>
                <p id="sydney_oppinion">‘‘Die Zusammenarbeit mit Sangeethan gestaltete sich von Anfang
                    bis Ende sehr lehrreich. Durch seine Teamfähigkeit
                    und lösungsorientiertes Denken, konnten wir in der Gruppe
                    zu jedem Problem, gemeinsam eine passende Lösung erarbeiten.
                    Seine positive Art ermutigte unsere Gruppe stets positiv,
                    was am Ende zu einem tollen Projektergebnis führte.
                    Danke für die Zusammenarbeit Sangee!’’</p>
            </div>

            <div class="single-review">
                <div>
                    <span class="collegue_name">Julia Friedrich</span>
                    <span class="project" id="project_join2">Projekt Join</span>
                </div>
                <p id="julia_oppinion">‘‘Sangeethan hat einen sauberen Code <br>
                    geschrieben, welches ermöglicht, <br>
                    dass das Projekt funktioniert. Er war <br>
                    für das Board und für die Funktionsweise des Projekts zuständig.’’</p>
            </div>
        </div>
    </div>

</div>